import ImageRegistry from '../../ImageRegistry';
import VirtualDomElement from '../VirtualDomElement';

export default class ImageElement extends VirtualDomElement {
  protected imageRegistry: ImageRegistry;

  constructor({
    x,
    y,
    url,
    maxWidth,
    minRatio = 0.6,
    maxRatio = 1,
    imageRegistry,
    onRequestDraw = () => null,
  }) {
    super(onRequestDraw);

    this.imageRegistry = imageRegistry;
    this.set('x', x);
    this.set('y', y);
    this.set('url', url);
    this.set('width', maxWidth);
    this.set('height', maxWidth * minRatio);
    this.set('loaded', false);
    this.set('minRatio', minRatio);
    this.set('maxRatio', maxRatio);

    if (imageRegistry.getImage(url)) {
      this.onLoad(imageRegistry.getImage(url));
    } else {
      imageRegistry.downloadImage(url, image => this.onLoad(image));
    }
  }

  onLoad(image) {
    this.set('naturalWidth', image.naturalWidth);
    this.set('naturalHeight', image.naturalHeight);

    const ratio = image.naturalHeight / image.naturalWidth;
    if (ratio < this.get('minRatio')) {
      this.set(
        'naturalWidth',
        (this.get('naturalHeight') * 1) / this.get('minRatio'),
      );
    } else if (ratio > this.get('maxRatio')) {
      this.set(
        'naturalHeight',
        this.get('naturalWidth') * this.get('maxRatio'),
      );
    }

    this.set(
      'height',
      (this.get('width') * this.get('naturalHeight')) /
        this.get('naturalWidth'),
    );
    this.set('loaded', true);
    this.requestDraw();
  }

  onError() {
    //url could not be loaded
    this.set('width', 0);
    this.set('height', 0);
  }

  draw(ctx, transform) {
    const url = this.getAttribute('url');
    const image = this.imageRegistry.getImage(url);
    if (image) {
      const width = this.get('width') * transform.k;
      const height = this.get('height') * transform.k;
      const [x, y] = transform.apply([
        this.getAttribute('x'),
        this.getAttribute('y'),
      ]);
      const naturalWidth = this.get('naturalWidth');
      const naturalHeight = this.get('naturalHeight');

      ctx.drawImage(
        image,
        0,
        0,
        naturalWidth,
        naturalHeight,
        x,
        y,
        width,
        height,
      );
    } else {
      this.imageRegistry.downloadImage(url);
    }
  }
}
